// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit group — a court sheet in the club colours, stacked on phone, split on desk. */
#adminRoot.group-form-theme {
  --eg-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --eg-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;
  --eg-pine: var(--brand-primary, #0877bc);
  --eg-tape: color-mix(in srgb, #fff 88%, var(--brand-primary, #0877bc));
  --eg-ink: var(--text-color, #0f172a);
  --eg-muted: var(--text-secondary, #64748b);
  --eg-line: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(15, 23, 42, 0.1)));
  color: var(--eg-ink);
  background-color: var(--bg-color);
  font-family: var(--eg-body);
}

.eg-sheet {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 14px calc(5.5rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eg-sheet *,
.eg-sheet *::before,
.eg-sheet *::after {
  box-sizing: border-box;
}

.eg-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.eg-file {
  display: none;
}

.eg-sheet__court {
  display: grid;
  grid-template-columns: 36px 1fr;
  overflow: visible;
  border-radius: 18px;
  border: 1px solid var(--eg-line);
  background: var(--surface-color, #fff);
  box-shadow: 0 16px 36px color-mix(in srgb, var(--eg-pine) 12%, transparent);
}

.eg-sheet__tape {
  border-radius: 18px 0 0 18px;
  overflow: hidden;
}

.eg-sheet__tape {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--eg-pine);
  box-shadow: inset -1px 0 0 color-mix(in srgb, #fff 16%, transparent);
}

.eg-sheet__tape span {
  font-family: var(--eg-display);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  line-height: 1;
  color: var(--eg-tape);
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.eg-sheet__stage {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.eg-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 168px;
  overflow: hidden;
  background:
    linear-gradient(90deg, color-mix(in srgb, #0b1f18 18%, transparent), transparent 18% 82%, color-mix(in srgb, #0b1f18 18%, transparent)),
    var(--eg-pine);
}

.eg-cover img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.eg-cover__empty {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--eg-tape);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
}

.eg-cover__btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--eg-pine);
  color: #fff;
  border: 3px solid var(--surface-color, #fff);
  box-shadow: 0 6px 16px color-mix(in srgb, var(--eg-pine) 45%, transparent);
  cursor: pointer;
}

.eg-cover__btn:focus-visible,
.eg-picker:focus-visible,
.eg-save:focus-visible,
.eg-stepper__btn:focus-visible,
.eg-name:focus-visible,
.eg-lede:focus-visible {
  outline: 2px solid var(--eg-pine);
  outline-offset: 2px;
}

.eg-identity {
  padding: 12px 14px 14px;
}

.eg-kicker {
  margin: 0 0 6px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--eg-pine);
}

.eg-name {
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--eg-ink);
  font-family: var(--eg-display);
  font-size: clamp(1.7rem, 7vw, 2.2rem);
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 0.95;
  text-transform: uppercase;
}

.eg-lede {
  width: 100%;
  margin: 8px 0 0;
  padding: 0;
  border: 0;
  resize: none;
  background: transparent;
  color: var(--eg-muted);
  font-family: var(--eg-body);
  font-size: 0.92rem;
  line-height: 1.4;
}

.eg-name::placeholder,
.eg-lede::placeholder {
  color: color-mix(in srgb, var(--eg-muted) 70%, transparent);
  text-transform: none;
  font-family: var(--eg-body);
  font-size: 0.95rem;
  letter-spacing: 0;
  font-weight: 500;
}

.eg-sheet__grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eg-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid var(--eg-line);
  background: var(--surface-color, #fff);
}

.eg-panel__head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--eg-pine);
}

.eg-panel__head h3 {
  margin: 0;
  font-family: var(--eg-display);
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--eg-ink);
}

.eg-panel__head p {
  margin: 2px 0 0;
  font-size: 0.78rem;
  color: var(--eg-muted);
}

.eg-picker,
.eg-sheet .MuiOutlinedInput-root {
  min-height: 48px !important;
  border-radius: 12px !important;
  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff)) !important;
  color: var(--eg-ink) !important;
  font-family: var(--eg-body) !important;
  font-size: 15px !important;
}

.eg-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--eg-line);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.eg-picker__count {
  min-width: 28px;
  padding: 2px 8px;
  border-radius: 999px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: var(--eg-pine);
}

.eg-placeholder {
  color: var(--eg-muted);
  font-weight: 500;
}

.eg-sheet .MuiOutlinedInput-notchedOutline {
  border-color: var(--eg-line) !important;
}

.eg-sheet .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--eg-pine) !important;
}

.eg-sheet .MuiSelect-select {
  padding: 12px !important;
}

.eg-chips {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.eg-chip {
  display: grid;
  grid-template-columns: 36px 1fr 28px;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 6px 8px 6px 6px;
  border-radius: 14px;
  border: 1px solid var(--eg-line);
  background: color-mix(in srgb, var(--eg-pine) 6%, var(--surface-color, #fff));
}

.eg-chip__avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  object-fit: cover;
}

.eg-chip__avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--eg-display);
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  background: var(--eg-pine);
}

.eg-chip__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.eg-chip__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.92rem;
  font-weight: 600;
}

.eg-chip__role {
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--eg-muted);
}

.eg-chip__remove {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: color-mix(in srgb, var(--eg-pine) 14%, transparent);
  color: var(--eg-pine);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.eg-session {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eg-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.eg-field > label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--eg-muted);
}

.eg-hint {
  margin: 0;
  font-size: 13px;
  color: var(--eg-muted);
}

.eg-level {
  display: grid;
  gap: 16px;
}

.eg-level__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.eg-level__chip--locked {
  opacity: 0.55;
}

.eg-kind-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eg-input,
.eg-select {
  width: 100%;
  min-height: 48px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--eg-line);
  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff));
  color: var(--eg-ink);
  font-family: var(--eg-body);
  font-size: 15px;
}

.eg-select {
  appearance: auto;
  cursor: pointer;
}

.eg-input:focus-visible,
.eg-select:focus-visible {
  outline: 2px solid var(--eg-pine);
  outline-offset: 2px;
}

.eg-join-rules {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eg-join-rules__row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  align-items: end;
}

.eg-join-rules__levels {
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--eg-line);
  background: color-mix(in srgb, var(--eg-pine) 5%, var(--surface-color, #fff));
}

.eg-join-rules__levels legend {
  padding: 0 4px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--eg-muted);
}

.eg-join-rules__checks {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
}

.eg-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--eg-ink);
  cursor: pointer;
}

.eg-check input {
  margin-top: 3px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: var(--eg-pine);
}

.eg-check--compact {
  font-size: 0.88rem;
}

.eg-panel--full {
  grid-column: 1 / -1;
}

.eg-stepper {
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  align-items: center;
  height: 48px;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid var(--eg-line);
  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff));
}

.eg-stepper input {
  width: 100%;
  height: 100%;
  border: 0;
  background: transparent;
  color: var(--eg-ink);
  font-family: var(--eg-display);
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  appearance: textfield;
}

.eg-stepper input::-webkit-outer-spin-button,
.eg-stepper input::-webkit-inner-spin-button {
  appearance: none;
}

.eg-stepper__btn {
  height: 100%;
  border: 0;
  background: var(--eg-pine);
  color: #fff;
  cursor: pointer;
}

.eg-dock {
  position: sticky;
  bottom: 0;
  z-index: 4;
  margin: 4px -14px 0;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));
  background:
    linear-gradient(180deg, transparent, var(--bg-color) 28%),
    var(--bg-color);
}

.eg-save {
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 14px;
  background: var(--eg-pine);
  color: #fff;
  font-family: var(--eg-display);
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 10px 22px color-mix(in srgb, var(--eg-pine) 38%, transparent);
}

.MuiMenu-paper.eg-menu {
  background: var(--surface-color, #fff) !important;
  color: var(--eg-ink) !important;
  border: 1px solid var(--eg-line) !important;
}

.eg-menu-item {
  min-height: 44px !important;
  font-family: var(--eg-body) !important;
}

.eg-menu-item.Mui-selected {
  background: color-mix(in srgb, var(--eg-pine) 14%, transparent) !important;
  color: var(--eg-pine) !important;
}

.dark-mode #adminRoot.group-form-theme .eg-sheet__court,
.dark-mode #adminRoot.group-form-theme .eg-panel {
  background: var(--surface-color, #111827);
}

.dark-mode #adminRoot.group-form-theme .eg-cover__btn {
  border-color: var(--surface-color, #111827);
}

@media (min-width: 860px) {
  .eg-sheet {
    max-width: 1080px;
    margin: 8px auto 32px;
    padding: 0 8px 24px;
    gap: 16px;
  }

  .eg-sheet__court {
    grid-template-columns: 44px 1fr;
    min-height: 280px;
  }

  .eg-sheet__stage {
    display: grid;
    grid-template-columns: minmax(280px, 0.9fr) 1.1fr;
  }

  .eg-cover {
    max-height: none;
    height: 100%;
    aspect-ratio: auto;
  }

  .eg-cover__btn {
    top: 12px;
    bottom: auto;
  }

  .eg-identity {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 28px 32px;
  }

  .eg-name {
    font-size: clamp(2.1rem, 3vw, 2.8rem);
  }

  .eg-sheet__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .eg-panel--session,
  .eg-panel--full {
    grid-column: 1 / -1;
  }

  .eg-sheet__stage {
    align-items: stretch;
  }

  .eg-identity {
    overflow: visible;
  }

  .eg-session {
    display: grid;
    grid-template-columns: 1.4fr 0.8fr;
    gap: 16px;
    align-items: end;
  }

  .eg-chips {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  .eg-dock {
    position: static;
    margin: 0;
    padding: 0;
    background: none;
    display: flex;
    justify-content: flex-end;
  }

  .eg-save {
    width: auto;
    min-width: 240px;
    padding: 0 28px;
  }
}

@media (prefers-reduced-motion: no-preference) {
  .eg-picker:active,
  .eg-save:active,
  .eg-stepper__btn:active {
    transform: scale(0.98);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/EditGroup.css"],"names":[],"mappings":"AAEA,qFAAqF;AACrF;EACE,oEAAoE;EACpE,0DAA0D;EAC1D,wCAAwC;EACxC,sEAAsE;EACtE,oCAAoC;EACpC,0CAA0C;EAC1C,4GAA4G;EAC5G,oBAAoB;EACpB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;EACd,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,2EAA2E;AAC7E;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,oEAAoE;AACtE;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB;;kBAEgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,4CAA4C;EAC5C,0EAA0E;EAC1E,eAAe;AACjB;;AAEA;;;;;;EAME,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,2DAA2D;EAC3D,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,8BAA8B;EAC9B,wFAAwF;EACxF,+BAA+B;EAC/B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,+DAA+D;EAC/D,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6EAA6E;EAC7E,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6EAA6E;AAC/E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,gEAAgE;EAChE;;mBAEiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,iDAAiD;EACjD,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iDAAiD;EACnD;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,4DAA4D;EAC9D;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,sBAAsB;EACxB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Edit group — a court sheet in the club colours, stacked on phone, split on desk. */\n#adminRoot.group-form-theme {\n  --eg-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --eg-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n  --eg-pine: var(--brand-primary, #0877bc);\n  --eg-tape: color-mix(in srgb, #fff 88%, var(--brand-primary, #0877bc));\n  --eg-ink: var(--text-color, #0f172a);\n  --eg-muted: var(--text-secondary, #64748b);\n  --eg-line: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color, rgba(15, 23, 42, 0.1)));\n  color: var(--eg-ink);\n  background-color: var(--bg-color);\n  font-family: var(--eg-body);\n}\n\n.eg-sheet {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 14px calc(5.5rem + env(safe-area-inset-bottom, 0px));\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eg-sheet *,\n.eg-sheet *::before,\n.eg-sheet *::after {\n  box-sizing: border-box;\n}\n\n.eg-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.eg-file {\n  display: none;\n}\n\n.eg-sheet__court {\n  display: grid;\n  grid-template-columns: 36px 1fr;\n  overflow: visible;\n  border-radius: 18px;\n  border: 1px solid var(--eg-line);\n  background: var(--surface-color, #fff);\n  box-shadow: 0 16px 36px color-mix(in srgb, var(--eg-pine) 12%, transparent);\n}\n\n.eg-sheet__tape {\n  border-radius: 18px 0 0 18px;\n  overflow: hidden;\n}\n\n.eg-sheet__tape {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--eg-pine);\n  box-shadow: inset -1px 0 0 color-mix(in srgb, #fff 16%, transparent);\n}\n\n.eg-sheet__tape span {\n  font-family: var(--eg-display);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  line-height: 1;\n  color: var(--eg-tape);\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n}\n\n.eg-sheet__stage {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.eg-cover {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  max-height: 168px;\n  overflow: hidden;\n  background:\n    linear-gradient(90deg, color-mix(in srgb, #0b1f18 18%, transparent), transparent 18% 82%, color-mix(in srgb, #0b1f18 18%, transparent)),\n    var(--eg-pine);\n}\n\n.eg-cover img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.eg-cover__empty {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--eg-tape);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.eg-cover__btn {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--eg-pine);\n  color: #fff;\n  border: 3px solid var(--surface-color, #fff);\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--eg-pine) 45%, transparent);\n  cursor: pointer;\n}\n\n.eg-cover__btn:focus-visible,\n.eg-picker:focus-visible,\n.eg-save:focus-visible,\n.eg-stepper__btn:focus-visible,\n.eg-name:focus-visible,\n.eg-lede:focus-visible {\n  outline: 2px solid var(--eg-pine);\n  outline-offset: 2px;\n}\n\n.eg-identity {\n  padding: 12px 14px 14px;\n}\n\n.eg-kicker {\n  margin: 0 0 6px;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--eg-pine);\n}\n\n.eg-name {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--eg-ink);\n  font-family: var(--eg-display);\n  font-size: clamp(1.7rem, 7vw, 2.2rem);\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  line-height: 0.95;\n  text-transform: uppercase;\n}\n\n.eg-lede {\n  width: 100%;\n  margin: 8px 0 0;\n  padding: 0;\n  border: 0;\n  resize: none;\n  background: transparent;\n  color: var(--eg-muted);\n  font-family: var(--eg-body);\n  font-size: 0.92rem;\n  line-height: 1.4;\n}\n\n.eg-name::placeholder,\n.eg-lede::placeholder {\n  color: color-mix(in srgb, var(--eg-muted) 70%, transparent);\n  text-transform: none;\n  font-family: var(--eg-body);\n  font-size: 0.95rem;\n  letter-spacing: 0;\n  font-weight: 500;\n}\n\n.eg-sheet__grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eg-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid var(--eg-line);\n  background: var(--surface-color, #fff);\n}\n\n.eg-panel__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  color: var(--eg-pine);\n}\n\n.eg-panel__head h3 {\n  margin: 0;\n  font-family: var(--eg-display);\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--eg-ink);\n}\n\n.eg-panel__head p {\n  margin: 2px 0 0;\n  font-size: 0.78rem;\n  color: var(--eg-muted);\n}\n\n.eg-picker,\n.eg-sheet .MuiOutlinedInput-root {\n  min-height: 48px !important;\n  border-radius: 12px !important;\n  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff)) !important;\n  color: var(--eg-ink) !important;\n  font-family: var(--eg-body) !important;\n  font-size: 15px !important;\n}\n\n.eg-picker {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--eg-line);\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n}\n\n.eg-picker__count {\n  min-width: 28px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  background: var(--eg-pine);\n}\n\n.eg-placeholder {\n  color: var(--eg-muted);\n  font-weight: 500;\n}\n\n.eg-sheet .MuiOutlinedInput-notchedOutline {\n  border-color: var(--eg-line) !important;\n}\n\n.eg-sheet .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--eg-pine) !important;\n}\n\n.eg-sheet .MuiSelect-select {\n  padding: 12px !important;\n}\n\n.eg-chips {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.eg-chip {\n  display: grid;\n  grid-template-columns: 36px 1fr 28px;\n  align-items: center;\n  gap: 8px;\n  min-height: 48px;\n  padding: 6px 8px 6px 6px;\n  border-radius: 14px;\n  border: 1px solid var(--eg-line);\n  background: color-mix(in srgb, var(--eg-pine) 6%, var(--surface-color, #fff));\n}\n\n.eg-chip__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  object-fit: cover;\n}\n\n.eg-chip__avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--eg-display);\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #fff;\n  background: var(--eg-pine);\n}\n\n.eg-chip__copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.eg-chip__name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.92rem;\n  font-weight: 600;\n}\n\n.eg-chip__role {\n  font-size: 0.7rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--eg-muted);\n}\n\n.eg-chip__remove {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--eg-pine) 14%, transparent);\n  color: var(--eg-pine);\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.eg-session {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eg-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.eg-field > label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--eg-muted);\n}\n\n.eg-hint {\n  margin: 0;\n  font-size: 13px;\n  color: var(--eg-muted);\n}\n\n.eg-level {\n  display: grid;\n  gap: 16px;\n}\n\n.eg-level__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.eg-level__chip--locked {\n  opacity: 0.55;\n}\n\n.eg-kind-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eg-input,\n.eg-select {\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--eg-line);\n  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff));\n  color: var(--eg-ink);\n  font-family: var(--eg-body);\n  font-size: 15px;\n}\n\n.eg-select {\n  appearance: auto;\n  cursor: pointer;\n}\n\n.eg-input:focus-visible,\n.eg-select:focus-visible {\n  outline: 2px solid var(--eg-pine);\n  outline-offset: 2px;\n}\n\n.eg-join-rules {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.eg-join-rules__row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n  align-items: end;\n}\n\n.eg-join-rules__levels {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--eg-line);\n  background: color-mix(in srgb, var(--eg-pine) 5%, var(--surface-color, #fff));\n}\n\n.eg-join-rules__levels legend {\n  padding: 0 4px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--eg-muted);\n}\n\n.eg-join-rules__checks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n}\n\n.eg-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--eg-ink);\n  cursor: pointer;\n}\n\n.eg-check input {\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: var(--eg-pine);\n}\n\n.eg-check--compact {\n  font-size: 0.88rem;\n}\n\n.eg-panel--full {\n  grid-column: 1 / -1;\n}\n\n.eg-stepper {\n  display: grid;\n  grid-template-columns: 48px 1fr 48px;\n  align-items: center;\n  height: 48px;\n  overflow: hidden;\n  border-radius: 12px;\n  border: 1px solid var(--eg-line);\n  background: color-mix(in srgb, var(--eg-pine) 7%, var(--surface-color, #fff));\n}\n\n.eg-stepper input {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: transparent;\n  color: var(--eg-ink);\n  font-family: var(--eg-display);\n  font-size: 1.4rem;\n  font-weight: 700;\n  text-align: center;\n  appearance: textfield;\n}\n\n.eg-stepper input::-webkit-outer-spin-button,\n.eg-stepper input::-webkit-inner-spin-button {\n  appearance: none;\n}\n\n.eg-stepper__btn {\n  height: 100%;\n  border: 0;\n  background: var(--eg-pine);\n  color: #fff;\n  cursor: pointer;\n}\n\n.eg-dock {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  margin: 4px -14px 0;\n  padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));\n  background:\n    linear-gradient(180deg, transparent, var(--bg-color) 28%),\n    var(--bg-color);\n}\n\n.eg-save {\n  width: 100%;\n  height: 50px;\n  border: 0;\n  border-radius: 14px;\n  background: var(--eg-pine);\n  color: #fff;\n  font-family: var(--eg-display);\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n  box-shadow: 0 10px 22px color-mix(in srgb, var(--eg-pine) 38%, transparent);\n}\n\n.MuiMenu-paper.eg-menu {\n  background: var(--surface-color, #fff) !important;\n  color: var(--eg-ink) !important;\n  border: 1px solid var(--eg-line) !important;\n}\n\n.eg-menu-item {\n  min-height: 44px !important;\n  font-family: var(--eg-body) !important;\n}\n\n.eg-menu-item.Mui-selected {\n  background: color-mix(in srgb, var(--eg-pine) 14%, transparent) !important;\n  color: var(--eg-pine) !important;\n}\n\n.dark-mode #adminRoot.group-form-theme .eg-sheet__court,\n.dark-mode #adminRoot.group-form-theme .eg-panel {\n  background: var(--surface-color, #111827);\n}\n\n.dark-mode #adminRoot.group-form-theme .eg-cover__btn {\n  border-color: var(--surface-color, #111827);\n}\n\n@media (min-width: 860px) {\n  .eg-sheet {\n    max-width: 1080px;\n    margin: 8px auto 32px;\n    padding: 0 8px 24px;\n    gap: 16px;\n  }\n\n  .eg-sheet__court {\n    grid-template-columns: 44px 1fr;\n    min-height: 280px;\n  }\n\n  .eg-sheet__stage {\n    display: grid;\n    grid-template-columns: minmax(280px, 0.9fr) 1.1fr;\n  }\n\n  .eg-cover {\n    max-height: none;\n    height: 100%;\n    aspect-ratio: auto;\n  }\n\n  .eg-cover__btn {\n    top: 12px;\n    bottom: auto;\n  }\n\n  .eg-identity {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 28px 32px;\n  }\n\n  .eg-name {\n    font-size: clamp(2.1rem, 3vw, 2.8rem);\n  }\n\n  .eg-sheet__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n\n  .eg-panel--session,\n  .eg-panel--full {\n    grid-column: 1 / -1;\n  }\n\n  .eg-sheet__stage {\n    align-items: stretch;\n  }\n\n  .eg-identity {\n    overflow: visible;\n  }\n\n  .eg-session {\n    display: grid;\n    grid-template-columns: 1.4fr 0.8fr;\n    gap: 16px;\n    align-items: end;\n  }\n\n  .eg-chips {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  }\n\n  .eg-dock {\n    position: static;\n    margin: 0;\n    padding: 0;\n    background: none;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .eg-save {\n    width: auto;\n    min-width: 240px;\n    padding: 0 28px;\n  }\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .eg-picker:active,\n  .eg-save:active,\n  .eg-stepper__btn:active {\n    transform: scale(0.98);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
